import { select, call, put } from "redux-saga/effects";
import FrontSonda from "@gcloud-npm/utils.monitoring.front-sonda";
import { isNumber } from '@bitComponents/utils/common';
import {
  getProductOfferingTextByType,
  getProductPromotionTextByType,
  replaceLocalizedString,
} from "../../utils/general";
import { STRING_KEYS } from "../../localizedStrings";
import {
  getPromotionInfo,
  getProductConditions,
} from "../../utils/normalizers";
import {
  CQ_POTS,
  CQ_ACTION_CODES,
  TEXT_TYPES_CODES,
  IVA,
} from "../../catalogConstants";
import {
  getProductTypeByProductOfferingTypes,
  PRODUCT_TYPES,
} from "../../utils/catalog";
import {
  actions as offerActions
} from '../../reducers/offer';
import { FLOW_TYPES } from "../../flowDefinition/flowTypes";

const FRONT_INCONSISTENCY_PRICE =
  "El precio recuperado de Telco difiere con el precio de cliente recuperado de Cloud.";
const FRONT_INCONSISTENCY_PRICE_ACTION =
  "Errores terminales TELCO: Precio en TELCO no coincide en Cloud";
const FRONT_SEGUIMIENTO_DE_ERRORES = "Seguimiento de errores";

const apisNeedsStore = (state) => state.apiNeeds;
const uiNeedsStore = (state) => state.uiNeeds;
const getLocalizedStrings = (state) => state.localizedStrings;
const offerStore = (state) => state.offer;
const flowStore = (state) => state.flow;

/**
 * Busca el impuesto aplicado en cada item y devuelve un array con dichos impuestos
 * @param {array} items Array con todos los items que potencialmente se pintarán en el carrito
 * @returns Array de impuestos aplicados
 */
function getTaxNamesApplied(items) {
  return items.filter((item)=>!item.isDowngraded).map((item) => item.taxName);
}

/**
 * Busca el impuesto aplicado en cada item y devuelve un array con dichos impuestos
 * @param {array} items Array con todos los items que potencialmente se pintarán en el carrito
 * @returns Array de impuestos aplicados
 */
function getPricesTaggingChoices(items) {
  return items.map((item) => `${item.productType || PRODUCT_TYPES.OTHER}:${item.actionId}`).join(":");
}

/**
 * Busca toda la info asociada a los items que se van a pintar en el carrito
 * @param {array} items Array con todos los items que potencialmente se pintarán en el carrito
 * @returns Array de información de la info para los items que se le pasa
 */
function* getProductInfoForCart({
  items,
  productOfferingToHire,
  poitSelected,
  isOneTimeCharges,
  manualPhoneNumberToPort
  }
) {
  const { localizedStrings } = yield select(getLocalizedStrings);
  const { productOfferingsToBuyInfo, deviceInfo } = yield select(uiNeedsStore);
  const { actualProductOffering, r2rInfo } = yield select(offerStore);
  const { insuranceData } = yield select(apisNeedsStore);

  let productOfferingName = "";
  if (productOfferingsToBuyInfo[actualProductOffering]) {
    productOfferingName =
      productOfferingsToBuyInfo[actualProductOffering].productOfferingName ||
      "";
  }

  const r2rPrices = [];
  
  const products = [];
  items.forEach((item) => {
    const { productOfferingTypes } = item;
    let shippingCostsAtCartAlready = false;
    item.customerQuoteItems.forEach((cqItem) => {
      const {
        productOffering,
        price,
        actionId,
        clientPhoneNumberToBeAppliedTo,
        items: cqItemSubItems,
        resourceSpecification,
      } = cqItem;
      if (productOffering && price) {
        let hideItemFromCart = false;
        let ordinaryText = getProductOfferingTextByType(
          productOffering,
          TEXT_TYPES_CODES.ORDINARY
        );

        // GET PRICE FOR R2R 
        const { id } = productOffering;
        if (r2rInfo.some(obj => obj.poId === id) && !isOneTimeCharges) {
          r2rPrices.push({
            id,
            price: price.finalPrice.amount,
          });
        }

        let swap = false;
        const r2rInfoObj = r2rInfo.find(obj => obj.poId === id);
        
        if (r2rInfoObj?.swap) {
          swap = true;
        }


        // END GET PRICE FOR R2R

        if (Array.isArray(cqItemSubItems)) {
          cqItemSubItems.forEach((cqItemSubItem) => {
            if (
              cqItemSubItem &&
              Array.isArray(cqItemSubItem.customerQuoteItems)
            ) {
              cqItemSubItem.customerQuoteItems.forEach(
                (cqItemSubItemCqItem) => {
                  if (
                    cqItemSubItemCqItem &&
                    cqItemSubItemCqItem.productOffering &&
                    cqItemSubItemCqItem.productOffering.characteristics &&
                    Array.isArray(
                      cqItemSubItemCqItem.productOffering.characteristics
                    )
                  ) {
                    const { characteristics } =
                      cqItemSubItemCqItem.productOffering;
                    characteristics.forEach((characteristic) => {
                      if (
                        characteristic &&
                        characteristic.id &&
                        characteristic.value &&
                        characteristic.value.id &&
                        STRING_KEYS.shoppingCart.characteristic[characteristic.id] &&
                        STRING_KEYS.shoppingCart.characteristic[characteristic.id][characteristic.value.id]
                      ) {
                        ordinaryText =
                          localizedStrings[STRING_KEYS.shoppingCart.characteristic[characteristic.id][characteristic.value.id]];
                      }
                    });
                  }
                }
              );
            }
          });
        }
        if (productOffering.id === productOfferingToHire && poitSelected) {
          if (
            STRING_KEYS.deviceInstallation[poitSelected] &&
            localizedStrings[STRING_KEYS.deviceInstallation[poitSelected].cartText]
          ) {
            ordinaryText =
              localizedStrings[
                STRING_KEYS.deviceInstallation[poitSelected].cartText
              ];
          }
        }
        const productType = getProductTypeByProductOfferingTypes(productOfferingTypes);
        if (
          isOneTimeCharges &&
          actionId === CQ_ACTION_CODES.REGISTER &&
          productType &&
          (productType === PRODUCT_TYPES.ADDITIONAL_R2R || 
          productType === PRODUCT_TYPES.INCLUDED_R2R) &&
          localizedStrings[STRING_KEYS.deviceSummaryCart.oneTimeChargesText]
        ) {
          if (!shippingCostsAtCartAlready) {
            ordinaryText =
            localizedStrings[STRING_KEYS.deviceSummaryCart.oneTimeChargesText];
            shippingCostsAtCartAlready = true;
          } else {
            hideItemFromCart = true;
          }
        }

        if (
          isOneTimeCharges &&
          actionId === CQ_ACTION_CODES.HGU_WITHOUT_COST &&
          localizedStrings[STRING_KEYS.deviceSummaryCart.hguWithoutCost]
        ) {
          if(resourceSpecification?.name){
            ordinaryText = resourceSpecification.name;
          } else {
            ordinaryText =
              localizedStrings[STRING_KEYS.deviceSummaryCart.hguWithoutCost];
          }
        }

        if (
          isOneTimeCharges &&
          actionId === CQ_ACTION_CODES.UHD_WITHOUT_COST &&
          localizedStrings[STRING_KEYS.deviceSummaryCart.uhdDecoderWithoutCost]
        ) {
          if(resourceSpecification?.name){
            ordinaryText = resourceSpecification.name;
          } else {
            ordinaryText = localizedStrings[STRING_KEYS.deviceSummaryCart.uhdDecoderWithoutCost];
          }
        }

        if (
          isOneTimeCharges &&
          actionId === CQ_ACTION_CODES.UHD_WIFI &&
          localizedStrings[STRING_KEYS.deviceSummaryCart.uhdWifiDecoder]
        ) {
          if(resourceSpecification?.name){
            ordinaryText = resourceSpecification.name;
          } else {
            ordinaryText = localizedStrings[STRING_KEYS.deviceSummaryCart.uhdWifiDecoder];
          }
        }

        if (
          isOneTimeCharges &&
          actionId === CQ_ACTION_CODES.EQUIPMENT_CHANGE_DUE_TO_DEPENDENT_OFFER &&
          resourceSpecification?.name
        ) {
            ordinaryText = resourceSpecification.name;
        }

        // VTL -> Se reemplaza el texto del carrito si solo hay un cargo que hace referencia a un terminal libre
        // El concepto pasa a ser el nombre recibido de catalogo COL (llamada a getTerminal)
        if (
          items.length === 1 &&
          productType &&
          productType === PRODUCT_TYPES.VTL &&
          productOfferingName
        ) {
          ordinaryText = productOfferingName;
        }

        const explanatoryText = getProductOfferingTextByType(
          productOffering,
          TEXT_TYPES_CODES.EXPLANATORY
        );
        // v8->v9 contingency: if they are not productPromotion,
        // we see if they are maintainedPromotions
        let { productPromotion } = productOffering;
        const { maintainedPromotions } = productOffering;

        // R2R duration
        const { terms } = productOffering;
        let additionalInfo;

        if (Array.isArray(terms) && !isOneTimeCharges) {
        
          const pocTerm = terms.find(
            (term) => term.type === CQ_POTS.COMMITMENT_POT.TYPE
          );
          if (pocTerm) {
            const { duration } = pocTerm;
            let swapText = localizedStrings[STRING_KEYS.summary.cart.alwaysNew];

            if (deviceInfo?.swapRenewalPeriod) {
              swapText = localizedStrings[STRING_KEYS.summary.cart.alwaysNewTemplate].replace('{months}', deviceInfo.swapRenewalPeriod);
            }

            if(localizedStrings[STRING_KEYS.summary.cart.alwaysNew] && swap && productType === PRODUCT_TYPES.ADDITIONAL_R2R && pocTerm.id === CQ_POTS.COMMITMENT_POT["36_MONTHS"]){
              additionalInfo = swapText
            } else if(localizedStrings[STRING_KEYS.summary.cart.alwaysNew] && swap && productType === PRODUCT_TYPES.INCLUDED_R2R){
              additionalInfo = swapText
            }
            else {
              if (duration) {
                const { amount } = duration;
                additionalInfo = replaceLocalizedString(
                  localizedStrings[STRING_KEYS.summary.cart.pocDuration],
                  {
                    "{duration}": amount,
                  }
                );
              }
            }
          }
        }
        let isMaintainingPromo = false;
        if (
          !productPromotion &&
          maintainedPromotions &&
          Array.isArray(maintainedPromotions) &&
          maintainedPromotions.length > 0
        ) {
          isMaintainingPromo = true;
          [productPromotion] = maintainedPromotions;
        }
        let productPromotionText = getProductPromotionTextByType(
          productPromotion,
          TEXT_TYPES_CODES.BRIEF
        );
        let productPromotionName = getProductPromotionTextByType(
          productPromotion,
          TEXT_TYPES_CODES.ORDINARY
        );
        if(isMaintainingPromo && productPromotion && productPromotion.promotionPeriod){
          const { promotionPeriod } = productPromotion;
          if(promotionPeriod.end) {
            productPromotionText = `Precio hasta ${promotionPeriod.end.toString()} *`
          }
        }

        if(productType === PRODUCT_TYPES.MOBILE_INSURANCE && insuranceData){

          productPromotionText = insuranceData.promotionalText;
          price.priceBeforeDiscounts = { amount: insuranceData.prices.priceBeforeDiscounts};
          price.finalPrice.amount = insuranceData.prices.finalPrice;
        }

        const chartElement = {
          productOffering: {
            id: productOffering.id,
            text: ordinaryText,
            description: explanatoryText,
          },
          promotionId: productPromotion ? productPromotion.id : null,
          promotionText: productPromotionText,
          promotionName: productPromotionName,
          priceBeforeDiscounts: price.priceBeforeDiscounts
            ? price.priceBeforeDiscounts.amount
            : null,
          actionId,
          clientPhoneNumberToBeAppliedTo: clientPhoneNumberToBeAppliedTo ? clientPhoneNumberToBeAppliedTo : actionId === CQ_ACTION_CODES.PORTABILITY && productType === PRODUCT_TYPES.MOBILE && manualPhoneNumberToPort ? manualPhoneNumberToPort : null,
          finalPrice: price.finalPrice ? price.finalPrice.amount : null,
          additionalInfo,
          taxName: price.taxShortName,
          productType,
        };
        if (resourceSpecification) {
          chartElement.resourceSpecification = resourceSpecification;
        }
        if (!hideItemFromCart) {
          products.push(chartElement);
        }
      }
    });
  });

  for (let i = 0; i < r2rPrices.length; i++) {
    yield put(offerActions.setR2RInfoPrice(r2rPrices[i].id, r2rPrices[i].price));
  }

  return products;
}

const normalizeTermsAndConditions = (productConditions, promotions, dataTransferTerms) => {
  let termsAndConditions = '';
  if(dataTransferTerms){
    termsAndConditions += dataTransferTerms;
  }
  if (Array.isArray(productConditions) && productConditions.length > 0) {
    productConditions.forEach((condition) => {
      const promotionInfo = promotions.find(
        (promotion) =>
          promotion.productOfferingId === condition.productOfferingId
      );
      if (
        (promotionInfo && promotionInfo.explanatoryText) ||
        condition.conditionText
      ) {
        let termToAppend = "";
        termToAppend += `<h1 class="termsAndConditionsTitle">${condition.productOfferingName}</h1>`;
        if (promotionInfo && promotionInfo.explanatoryText) {
          termToAppend +=
            '<h2 class="termsAndConditionsSubtitle">Condiciones promoción</h2>';
          termToAppend += `<p class="termsAndConditionsParagraph">${promotionInfo.explanatoryText}</p>`;
        }
        if (condition.conditionText) {
          termToAppend += `<p class="termsAndConditionsParagraph">${condition.conditionText}</p>`;
        }
        termsAndConditions += termToAppend;
      }
    });
  } else if(Array.isArray(promotions)){
    promotions.forEach((promotionInfo)=>{
      if (
        (promotionInfo && promotionInfo.explanatoryText)
      ) {
        let termToAppend = "";
        if (promotionInfo && promotionInfo.explanatoryText) {
          termToAppend +=
            '<h2 class="termsAndConditionsSubtitle">Condiciones promoción</h2>';
          termToAppend += `<p class="termsAndConditionsParagraph">${promotionInfo.explanatoryText}</p>`;
        }
        termsAndConditions += termToAppend;
      }
    })
  }

  return termsAndConditions;
};

/**
 * Normaliza la información de precios para que sea pintada en el carrito
 * @param {object} getCQPricesInfo Información que nos viene del api getCQPrices
 * @returns Información de precios normalizada para el carrito
 */
export function* normalizeShoppingCartPrices(components, manualPhoneNumberToPort = null) {
  const apiNeeds = yield select(apisNeedsStore);
  const offer = yield select(offerStore);
  const { flowJson } = yield select(flowStore);
  const { localizedStrings } = yield select(getLocalizedStrings);

  const { avoidLegalsExplanatory, avoidAfterSaleLegalsExplanatory, sendDiscrepancyAlarmInOneTimeCharges, sendDiscrepancyAlarmInRecurringCharges, forcedOneTimePriceIfNull, flowName } = flowJson;

  const { poitSelected, afterSaleProduct} = apiNeeds;
  const { productOffering, vval } = offer;

  const charges = {
    recurringCharges: {},
    oneTimeCharges: {},
    promotions: [],
    termsAndConditions: "",
    taxName: "",
    haveMaintainingPromo: false,
    taggingChoices: '',
  };
  let productConditions = [];
  if (components.recurringCharges) {
    const { totalPrice, items } = components.recurringCharges;

    const promotions = [];
    items.forEach((cartItem) => {
      if (
        cartItem &&
        cartItem.customerQuoteItems &&
        Array.isArray(cartItem.customerQuoteItems)
      ) {
        cartItem.customerQuoteItems.forEach((cqItem) => {
          const promotionTexts = getPromotionInfo(cqItem);
          if (promotionTexts) {
            const { regularText, explanatoryText, id, productOfferingId, isMaintainingPromo, productWithMaintainedPromo } = promotionTexts;
            if(isMaintainingPromo){
              charges.haveMaintainingPromo = isMaintainingPromo;
            }
            promotions.push({
              regularText,
              explanatoryText,
              id,
              productOfferingId,
              productWithMaintainedPromo,
            });
          }
        });
      }
    });
    if (!avoidLegalsExplanatory) {
      productConditions = productConditions.concat(getProductConditions(items, avoidAfterSaleLegalsExplanatory));
    }

    if (totalPrice.finalPrice) {
      const { amount: amountGroupPrice } = totalPrice.finalPrice;
      const charge = {
        products: yield call(
          getProductInfoForCart,
          {
            items,
            productOfferingToHire: productOffering,
            poitSelected: null,
            isOneTimeCharges: false,
            manualPhoneNumberToPort
          }
        ),
        groupPrice: amountGroupPrice,
      };
      const taxNames = getTaxNamesApplied(charge.products);
      const allItemWithSameTax = taxNames.every((tax) => tax === taxNames[0]);
      if (allItemWithSameTax && taxNames[0] === IVA) {
        if (
          isNumber(vval) &&
          vval !== amountGroupPrice &&
          sendDiscrepancyAlarmInRecurringCharges
        ) {
          const errMsgDatalayer = `${FRONT_INCONSISTENCY_PRICE};Precio_Ficha:${vval}-Precio_Telco:${amountGroupPrice};`;
          const frontSonda = new FrontSonda({
            processName: "normalizeShoppingCartPrices",
            filePath: "sagas/getCQPrices",
          });
          frontSonda.severalMessage({ info: errMsgDatalayer });
          const { dataLayerGTM } = window;
          if (dataLayerGTM) {
            dataLayerGTM.push({
              event: "asyncGTM",
              GAcategory: FRONT_SEGUIMIENTO_DE_ERRORES,
              GAaction: FRONT_INCONSISTENCY_PRICE_ACTION,
              GAlabel: errMsgDatalayer,
            });
          }
        }
      }

      if (
        totalPrice.priceBeforeDiscounts &&
        totalPrice.priceBeforeDiscounts.amount &&
        totalPrice.priceBeforeDiscounts.amount !== totalPrice.finalPrice.amount
      ) {
        charge.groupPriceBeforeDiscounts =
          totalPrice.priceBeforeDiscounts.amount;
      }

      charges.recurringCharges = charge;
      charges.promotions = promotions;
    }
  }

  // Normaliza los downgrades de paquetes de TV para mostrarlos en el carrito como parte de los recurringCharges
  if (components.downgrades) {
    const charge = charges.recurringCharges;
    const { items: itemsToDowngrade } = components.downgrades;
    const productsToDowngrade = [];
    itemsToDowngrade.forEach((cartItemToDowngrade) => {
      const { productOfferingTypes } = cartItemToDowngrade;
      const productType =
        getProductTypeByProductOfferingTypes(productOfferingTypes);
      if (
        cartItemToDowngrade &&
        cartItemToDowngrade.customerQuoteItems &&
        Array.isArray(cartItemToDowngrade.customerQuoteItems)
      ) {
        cartItemToDowngrade.customerQuoteItems.forEach((cqItem) => {
          if (cqItem.productOffering) {
            const ordinaryText = getProductOfferingTextByType(
              cqItem.productOffering,
              TEXT_TYPES_CODES.ORDINARY
            );
            const productToDowngrade = {
              productOffering: {
                id: cqItem.productOffering.id,
                text: ordinaryText,
              },
              productType,
              actionId: cqItem.actionId,
              isDowngraded: true,
            };
            if (productType && (productType === PRODUCT_TYPES.TV || productType === PRODUCT_TYPES.NETFLIX)) {
              productsToDowngrade.push(productToDowngrade);
            } else {
              const frontSonda = new FrontSonda({
                processName: "normalizeShoppingCartPrices",
                filePath: "sagas/getCQPrices",
              });
              frontSonda.severalMessage({ info: `Se ha recibido un item de baja en el carro diferente a paquetes de TV: ${productToDowngrade.productOffering.id}` });
            }
          }
        });
      }
    });
    if (charge && charge.products) {
      charge.products.push(...productsToDowngrade);
      charges.recurringCharges = charge;
    } else {
      const charge = {
        products: [...productsToDowngrade],
        groupPrice: null,
      };
      charges.recurringCharges = charge;
    }
  }


  if (components.oneTimeCharges) {
    const { totalPrice, items } = components.oneTimeCharges;
    const { finalPrice } = totalPrice;
    if (!avoidLegalsExplanatory) {
      productConditions = productConditions.concat(getProductConditions(items, avoidAfterSaleLegalsExplanatory));
    }
    if (finalPrice) {
      const { amount } = finalPrice;
      
      const charge = {
        products: yield call(
          getProductInfoForCart,
          {
            items,
            productOfferingToHire: productOffering,
            poitSelected,
            isOneTimeCharges: true,
            manualPhoneNumberToPort: null,
          }
        ),
        groupPrice: amount,
      };
      const taxNames = getTaxNamesApplied(charge.products);
      const allItemWithSameTax = taxNames.every((tax) => tax === taxNames[0]);
      if (allItemWithSameTax && taxNames[0] === IVA) {
        if (
          isNumber(vval) &&
          vval !== amount &&
          sendDiscrepancyAlarmInOneTimeCharges
        ) {
          const errMsgDatalayer = `${FRONT_INCONSISTENCY_PRICE};Precio_Ficha:${vval}-Precio_Telco:${amount};`;
          const frontSonda = new FrontSonda({
            processName: "normalizeShoppingCartPrices",
            filePath: "sagas/getCQPrices",
          });
          frontSonda.severalMessage({ info: errMsgDatalayer });
          const { dataLayerGTM } = window;
          if (dataLayerGTM) {
            dataLayerGTM.push({
              event: "asyncGTM",
              GAcategory: FRONT_SEGUIMIENTO_DE_ERRORES,
              GAaction: FRONT_INCONSISTENCY_PRICE_ACTION,
              GAlabel: errMsgDatalayer,
            });
          }
        }
      }
      
      if (
        totalPrice.priceBeforeDiscounts &&
        totalPrice.priceBeforeDiscounts.amount &&
        totalPrice.priceBeforeDiscounts.amount !== totalPrice.finalPrice.amount
      ) {
        charge.groupPriceBeforeDiscounts =
          totalPrice.priceBeforeDiscounts.amount;
      }

      charges.oneTimeCharges = charge;
    } else if(flowName === FLOW_TYPES.E_SIM && forcedOneTimePriceIfNull !== undefined && afterSaleProduct?.name){
      const charge = {
        products: [{
          productOffering: {
            id: afterSaleProduct.cisi,
            text: afterSaleProduct.name,
          },
          promotionId: null,
          promotionText: '',
          priceBeforeDiscounts: null,
          finalPrice: forcedOneTimePriceIfNull,
          taxName: IVA,
          productType: PRODUCT_TYPES.E_SIM,
        }],
        groupPrice: forcedOneTimePriceIfNull,
      };
      charges.oneTimeCharges = charge;
    }
  }
  const allItems = [];
  if (charges.oneTimeCharges && charges.oneTimeCharges.products) {
    allItems.push(...charges.oneTimeCharges.products);
  }
  if (charges.recurringCharges && charges.recurringCharges.products) {
    charges.taggingChoices = getPricesTaggingChoices(charges.recurringCharges.products);
    allItems.push(...charges.recurringCharges.products);
  }
  const taxNames = getTaxNamesApplied(allItems);
  const allItemWithSameTax = taxNames.every((tax) => tax === taxNames[0]);
  if (allItemWithSameTax) {
    const taxName = taxNames[0];
    charges.taxName = taxName;
  }
  const uniqueConditions = productConditions.filter((value, index, self) => index === self.findIndex(item => (
    item.productOfferingId === value.productOfferingId
  )));

  let dataTransferTerms = '';
  if (
    localizedStrings[STRING_KEYS.legalNSubmit.dataTransferTitle] &&
    localizedStrings[STRING_KEYS.legalNSubmit.dataTransferText]
  ) {
    dataTransferTerms = `<h1 class="termsAndConditionsTitle">${localizedStrings[STRING_KEYS.legalNSubmit.dataTransferTitle]}</h1>`
    dataTransferTerms += `<p class="termsAndConditionsParagraph">${localizedStrings[STRING_KEYS.legalNSubmit.dataTransferText]}</p>`;
  }

  charges.termsAndConditions = normalizeTermsAndConditions(uniqueConditions, charges.promotions, dataTransferTerms);
  return charges;
}
